import {
  ApolloClient,
  InMemoryCache,
  HttpLink,
  ApolloLink,
  ApolloProvider,
  gql,
  concat,
} from "@apollo/client";

const httpLink = new HttpLink({
  uri: "https://nt37kx5i6bb7tjpe5lhatluojy.appsync-api.ap-south-1.amazonaws.com/graphql",
  fetchOptions: {
    timeout: 60000, // Set the timeout value in milliseconds (adjust as needed)
  },
});

const authMiddleware = new ApolloLink((operation, forward) => {
  // add the authorization to the headers
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      "x-api-key": "da2-y2iojnlkrjc3lafr2x2qf3c4ii",
    },
  }));

  return forward(operation);
});

const without_client = new ApolloClient({
  cache: new InMemoryCache(),
  link: concat(authMiddleware, httpLink),
});

export default without_client;
